var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoupon2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5816 2.58384C12.2067 2.20887 11.6983 1.99816 11.1681 1.99805H3.9986C3.46835 1.99805 2.95982 2.20869 2.58488 2.58363C2.20994 2.95857 1.9993 3.4671 1.9993 3.99735V11.1668C1.99941 11.697 2.21013 12.2055 2.58509 12.5803L11.286 21.2813C11.7404 21.7328 12.3549 21.9862 12.9954 21.9862C13.636 21.9862 14.2505 21.7328 14.7048 21.2813L21.2825 14.7036C21.734 14.2492 21.9874 13.6347 21.9874 12.9942C21.9874 12.3537 21.734 11.7391 21.2825 11.2848L12.5816 2.58384Z",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49756 7.99805C7.7737 7.99805 7.99756 7.77419 7.99756 7.49805C7.99756 7.2219 7.7737 6.99805 7.49756 6.99805C7.22142 6.99805 6.99756 7.2219 6.99756 7.49805C6.99756 7.77419 7.22142 7.99805 7.49756 7.99805Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.9993,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupon2);
export default __webpack_public_path__ + "static/media/coupon2.848772640ddc5d136ce14b663e5c35b2.svg";
export { ForwardRef as ReactComponent };